// // import React, { useState } from "react";  
// // import { Link } from "react-router-dom";  
// // import "./navbar.css";  
// // import profileLogo from '../images/Profile.png';   
  
// // export default function Navbar() {  
// //     const [isMenuOpen, setMenuOpen] = useState(false);  
// //     const [isDropdownOpen, setDropdownOpen] = useState(false);  
  
// //     function toggleMenu() {  
// //         setMenuOpen((prevState) => !prevState);  
// //     }  
  
// //     function toggleDropdown() {  
// //         setDropdownOpen((prevState) => !prevState);  
// //         if (isMenuOpen) {  
// //             setMenuOpen(false);  
// //         }  
// //     }  
  
// //     function handleClick() {  
// //         setMenuOpen(false);  
// //         setDropdownOpen(false);  
// //     }  
  
// //     function DropdownClick() {  
// //         setDropdownOpen((prevState) => !prevState);  
// //         setMenuOpen(false);  
// //     }  
  
// //     return (  
// //         <nav className="navbar">  
// //             <div className="menu-btn" onClick={toggleMenu}>  
// //                 <div className="menu-btn__burger"></div>  
// //             </div>  
// //             <div className={`sliding-menu ${isMenuOpen ? "show" : ""}`}>  
// //                 <div className="close-btn" onClick={toggleMenu}>  
// //                     &times;  
// //                 </div>  
// //                 <ul>  
// //                     {/* <li>  
// //                         <Link to="/dashboard" onClick={handleClick}>Dashboard</Link>  
// //                     </li>   */}
// //                     <li>  
// //                         <Link to="/broadcastmessage" onClick={handleClick}>Broadcast</Link>  
// //                     </li>  
// //                     <li>  
// //                         <Link to="/kpidetails" onClick={handleClick}>KPI</Link>  
// //                     </li>  
// //                     <li>  
// //                         <Link to="/feedback" onClick={handleClick}>Feedback</Link>  
// //                     </li>  
// //                     <li>  
// //                         <Link to="/km-analysis" onClick={handleClick}>KM Analysis</Link>  
// //                     </li>  
// //                 </ul>  
// //             </div>  
// //             <div className="profile-section">  
// //                 <img  
// //                     src={profileLogo}  
// //                     alt="Profile"  
// //                     className="profile-icon"  
// //                     onClick={toggleDropdown}  
// //                 />  
// //                 {isDropdownOpen && (  
// //                     <div className="dropdown-menu">  
// //                         {/* <Link to="/profile" className="dropdown-item" onClick={DropdownClick}>  
// //                             Profile  
// //                         </Link>   */}
// //                         <Link to="/" className="dropdown-item" onClick={DropdownClick}>  
// //                             Logout  
// //                         </Link>  
// //                     </div>  
// //                 )}  
// //             </div>  
// //         </nav>  
// //     );  
// // }  

// import React, { useState ,useEffect } from "react";
// import { Link } from "react-router-dom";
// import "./navbar.css";
// import profileLogo from '../images/Profile.png';
// import appLogo from "../Webpage/utils/outline.png";
// import { NavLink } from "react-router-dom";

// export default function Navbar() {
//   const [isDropdownOpen, setDropdownOpen] = useState(false);

//   function toggleDropdown() {
//     setDropdownOpen((prev) => !prev);
//   }

//   function closeDropdown() {
//     setDropdownOpen(false);
//   } 

//   async function handleLogout(e) {
//     e.preventDefault();
//     const confirmLogout = window.confirm('Are you sure you want to logout?'); // Use window.confirm instead of alert for confirmation
  
//     if (confirmLogout) {
//       try {
//         // Send a request to the backend to logout
//         const response = await fetch('/logout', {
//           method: 'GET', // Or 'POST' if you prefer
//           credentials: 'include', // Ensure cookies are sent along with the request
//         });
  
//         if (!response.ok) {
//           throw new Error('Failed to log out');
//         }
  
//         // Optionally, redirect to the homepage after successful logout
//         window.location.href = '/';
//       } catch (error) {
//         console.error('Logout error:', error);
//         // Handle any errors here, e.g., show an error message
//       }
//     }
//   }
  
  

//   return (
//     <nav className="navbar">
//       {/* Left: Logo */}
//           <div className="navbar-left" style={{display:"flex", alignItems:"center", justifyContent:"center"}}>
//               <div>
//                   <img src={appLogo} alt="Logo" className="app-logo" />
//               </div>
//                 <div style={{width:"20px"}}></div>
//               {/* Center: Navigation */}
//               <ul className="navbar-links">
//                   <li>
//                       <NavLink
//                           to="/broadcastmessage"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           Broadcast
//                       </NavLink>
//                   </li>

//                   <li>
//                       <NavLink
//                           to="/kpidetails"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           KPI
//                       </NavLink>
//                   </li>

//                   <li>
//                       <NavLink
//                           to="/feedback"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           Feedback
//                       </NavLink>
//                   </li>

//                   <li>
//                       <NavLink
//                           to="/kmanalysis"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           KM Analysis
//                       </NavLink>
//                   </li>

//                   <li>
//                       <NavLink
//                           to="/transcript"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           Transcript
//                       </NavLink>
//                   </li>

//                   {/* <li>
//                       <NavLink
//                           to="/kmfilter"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           KM Filters
//                       </NavLink>
//                   </li> */}
//                   <li>
//                       <NavLink
//                           to="/outage-info"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           Outage Details
//                       </NavLink>
//                   </li>
//                        <li>
//                       <NavLink
//                           to="/accessmanagement"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           AccessManagement
//                       </NavLink>
//                   </li>
//                        <li>
//                       <NavLink
//                           to="/broadcastReport"
//                           className={({ isActive }) => (isActive ? "active-link" : "")}
//                       >
//                           Broadcast Report
//                       </NavLink>
//                   </li>
//               </ul>

//           </div>
//       {/* Right: Profile */}
//       <div className="navbar-right">
//         <img
//           src={profileLogo}
//           alt="Profile"
//           className="profile-icon"
//           onClick={handleLogout}
//         />

//         {/* {isDropdownOpen && (
//                     <div className="dropdown-menu">
//                         <a href="/logout" className="dropdown-item" onClick={handleLogout}>
//                             Logout
//                         </a>
//                     </div>
//                 )} */}
 
//       </div>
//     </nav>
//   );
// }
import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";
import profileLogo from '../images/Profile.png';
import appLogo from "../Webpage/utils/outline.png";

// Keep these `feature` keys in sync with FEATURES in AccessManagementPage.js
const NAV_ITEMS = [
  { to: "/broadcastmessage", label: "Broadcast", feature: "broadcast" },
  { to: "/kpidetails", label: "KPI", feature: "kpi" },
  { to: "/feedback", label: "Feedback", feature: "feedback" },
  { to: "/kmanalysis", label: "KM Analysis", feature: "kmanalysis" },
  { to: "/transcript", label: "Transcript", feature: "transcript" },
  { to: "/outage-info", label: "Outage Details", feature: "outage" },
  { to: "/accessmanagement", label: "AccessManagement", feature: "access-management" },
  { to: "/broadcastReport", label: "Broadcast Report", feature: "broadcastreport" },
];

export default function Navbar() {
  const [allowedFeatures, setAllowedFeatures] = useState([]);
  const [accessLoaded, setAccessLoaded] = useState(false);

  useEffect(() => {
    let isMounted = true;
    (async () => {
      try {
        const res = await fetch("/api/access/mine", { credentials: "include" });
        const data = await res.json();
        if (isMounted) setAllowedFeatures(data.features || []);
      } catch (err) {
        console.error("Failed to load access permissions:", err);
        if (isMounted) setAllowedFeatures([]);
      } finally {
        if (isMounted) setAccessLoaded(true);
      }
    })();
    return () => { isMounted = false; };
  }, []);

  async function handleLogout(e) {
    e.preventDefault();
    const confirmLogout = window.confirm('Are you sure you want to logout?');
    if (confirmLogout) {
      try {
        const response = await fetch('/logout', {
          method: 'GET',
          credentials: 'include',
        });
        if (!response.ok) {
          throw new Error('Failed to log out');
        }
        window.location.href = '/';
      } catch (error) {
        console.error('Logout error:', error);
      }
    }
  }

  return (
    <nav className="navbar">
      <div className="navbar-left" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
        <div>
          <img src={appLogo} alt="Logo" className="app-logo" />
        </div>
        <div style={{ width: "20px" }}></div>

        <ul className="navbar-links">
          {accessLoaded && NAV_ITEMS.map((item) => {
            const hasAccess = allowedFeatures.includes(item.feature);
            return (
              <li key={item.to}>
                {hasAccess ? (
                  <NavLink
                    to={item.to}
                    className={({ isActive }) => (isActive ? "active-link" : "")}
                  >
                    {item.label}
                  </NavLink>
                ) : (
                  <span
                    className="nav-link-disabled"
                    title="You don't have access to this feature"
                  >
                    {item.label}
                  </span>
                )}
              </li>
            );
          })}
        </ul>
      </div>

      <div className="navbar-right">
        <img
          src={profileLogo}
          alt="Profile"
          className="profile-icon"
          onClick={handleLogout}
        />
      </div>
    </nav>
  );
}